import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { StateService, trace } from '@uirouter/angular';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";
import {OnClickEvent, OnRatingChangeEven, OnHoverRatingChangeEvent} from "angular-star-rating/star-rating-struct";
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-redeem-coupon',
  templateUrl: './redeem-coupon.component.html',
  styleUrls: ['./redeem-coupon.component.scss']
})
export class RedeemCouponComponent implements OnInit {
  loading = false;
  currency = [];
  searchCurrency = "";
  modalRef: NgbModalRef;
  closeResult: any;
  reviewForm = {};
  couponForm = {};
  transaction = {};
  showresult = false;
  showCouponDetail = false;
  correctCouponForm = false;
  couponMsg = '';
  redeemData = {};
  currentCouponCode = '';
  productArray = [];
  redeemPhone = "";


  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private stateService: StateService,
    private frontEndService: FrontEndService,
    private dataService: DataService,
    private logService: LogService
  ) { }

  @ViewChild("infoPanel") infoPanel;
  @ViewChild("reviewModalContent") private reviewModalContent: ElementRef;

  ngOnInit() {
    this.currency = this.dataService.currencyList;
    this.reviewForm["feedback"] = "None";
  }
  

  typeCouponCode(scanner = false) {

    this.couponForm['user_id'] = this.dataService.userDetails['user_id'];

    if (!scanner) {
      this.couponForm['coupon_code'] = this.couponForm['coupon_code'].toUpperCase();
    }

    this.loading = true;
    
    // this.couponForm['coupon_code'] = this.couponForm['coupon_code'].toUpperCase();

    this.apiService.typeCoupon(this.couponForm, (response) => {
      // this.logService.printLog("Check redeem coupon -", response)
      // this.logService.printLog(response.message);
      this.loading = false;
      
      // this.currentCouponCode = this.couponForm["coupon_code"];
      if(response.message == "Coupon not found") {
        this.correctCouponForm = false;
        response['coupon_code'] = this.couponForm['coupon_code'];
        this.productArray.unshift(response);
        this.showCouponDetail = true;
        this.infoPanel.getProductData();
        this.infoPanel.isProduct = false;
        this.couponForm['coupon_code'] = '';
      }else {
        this.couponForm = response;
        this.correctCouponForm = true;
        this.productArray = [];
      }
    });
  }

  codeDetected(event) {
    this.logService.printLog('scan code', event);
    this.couponForm['coupon_code'] = event.toUpperCase();
    this.typeCouponCode();
  }

  redeemCoupon(){
    // this.logService.printLog(this.couponForm);
    this.reviewForm["user_id"] = this.dataService.userDetails['user_id'];
    this.reviewForm["coupon_code"] = this.currentCouponCode;
    this.loading = true;
    this.apiService.redeemCoupon(this.reviewForm, this.redeemCouponCallBack);
    // this.logService.printLog(this.reviewForm);
    // this.logService.printLog("redeem coupon response -", this.reviewForm['response']);
    this.loading = false;
    this.correctCouponForm = false;
  }

  redeemCouponCallBack = (response) => {
    // this.logService.printLog("Reddem test coupon -", response);
    this.showresult = true;
    // this.redeemData = response;
    response.showresult = true;
    response.coupon_code = this.currentCouponCode;
    response.phone_number =  this.reviewForm['phone_number'];
    response.code = this.couponForm['coupon_code'];
    this.couponForm['coupon_code'] = '';
    this.productArray = [];
    this.productArray.unshift(response);
  }

  onClick = ($event:OnClickEvent) => {
    // this.logService.printLog('onClick $event: ', $event);
    this.reviewForm['product_rating'] = $event.rating;
  };
  
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/redeem-coupon/redeem-coupon.component.ts